import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux';

import user from './user';
import response from './response';
import aclass from './aclass';
import subscription from './subscription';
import review from './review';
import tutor from './tutor';
import competition from './competition';
import {socket_reducer}  from './websocket';

export default combineReducers({
  router: routerReducer,
  user,
  aclass,
  competition,
  response,
  subscription,
  review,
  tutor,
  socket_reducer
})
